/** @format */

export const BASE_URL = 'https://api.hydrologyfromspace.org';
export const BASE_URL2 = 'https://api.hydrologyfromspace.org';
export const BASE_URL3 = 'http://localhost:8095/db/';
export const TILE_URL2 = 'https://tile.hydrologyfromspace.org';
export const TILE_URL = '/map';
export const IMAGE_URL = 'file:///app/images';
export const IMAGE_URL2 = 'https://hydrologyfromspace.org/images';
export const COG_URL = 'cog/tiles/WebMercatorQuad/{z}/{x}/{y}.png';
export const GEOJSON_URL = 'http://localhost:8095/geojson/vs_All.geojson';
export const GEOJSON_URL2 = 'https://hydrologyfromspace.org/assets/data/geojson/vs_All.geojson';

export const COLLECTION_NAME = 'api/vstations';

export const bgColor = '#312f38';
export const bgColorButton = '#44414d';
export const bgColorBox = '#615d6f';
export const bgColorButtonTitle = '#f0f0f0';

export const styleGray = {
	bg: '#312f38',
	bgButton: '#44414d',
	bgButtonHover: '#565262',
	bgButtonActive: '#565262',
	borderColor: '#28262e',
	borderColorHover: '#767187',
	borderColorActive: '#f0f0f0',
	bgBox: '#615d6f',
	colorButtonTitle: '#f0f0f0',
	boxShadowFocus: '0 0 0 0.2rem rgba(64,70,74,.5)',
};

export const sColors = {
	red: '#8f0000',
	orange: '#ff9400',
	orangeLight: '#fbc500',
	yellow: '#f9f602',
	blueLight: '#b2d9ff',
	blue: '#0080ff',
	blueDark: '#004d99',
	blueExtra: '#001a33',
};

export const getChangeCellClassName = (params) => {
	if (params.value >= 1.5) {
	  return 'css-change--cell-positive4';
	} else if (params.value > 1.0) {
	  return 'css-change--cell-positive3';
	} else if (params.value > 0.5) {
	  return 'css-change--cell-positive2';
	} else if (params.value >= 0) {
	  return 'css-change--cell-positive1';
	} else if (params.value >= -0.5) {
	  return 'css-change--cell-negative1';
	} else if (params.value >= -1.0) {
	  return 'css-change--cell-negative2';
	} else if (params.value >= -1.5) {
	  return 'css-change--cell-negative3';
	} else if (params.value < -1.5) {
	  return 'css-change--cell-negative4';
	}
  };


export const riversList = [
	{ river: 'ABACAXIS' },
	{ river: 'ABACAXIS-TRIB01' },
	{ river: 'ABUFARI' },
	{ river: 'ABUJAO' },
	{ river: 'ABUNA' },
	{ river: 'ABUNA-TRIB-04' },
	{ river: 'ACAPU' },
	{ river: 'ACARI' },
	{ river: 'ACRE' },
	{ river: 'ACRE-RIVER-RIO-XAPURI' },
	{ river: 'ACRE-TRIB-01' },
	{ river: 'ACUARAUA' },
	{ river: 'AGUA-BOA-DO-UNIVINI' },
	{ river: 'AGUARAY-GUAZU' },
	{ river: 'AGUARICO' },
	{ river: 'AGUARICO-TRIB01' },
	{ river: 'AGUAYTIA' },
	{ river: 'AGUAYTIA-TRIB01' },
	{ river: 'AIARI' },
	{ river: 'AIUANA' },
	{ river: 'AJAJU' },
	{ river: 'ALALAU' },
	{ river: 'ALEGRE' },
	{ river: 'ALGODON' },
	{ river: 'ALTO-MADRE-DE-DIOS-TRIB-01' },
	{ river: 'ALTO-MADRE-DE-DIOS-TRIB-03' },
	{ river: 'AMAJARI' },
	{ river: 'AMAZON' },
	{ river: 'AMAZONAS' },
	{ river: 'AMAZONAS-PERU-TRIB01' },
	{ river: 'AMAZONAS-TRIB-01' },
	{ river: 'AMAZONAS-TRIB-02' },
	{ river: 'AMAZONAS-TRIB-09' },
	{ river: 'AMAZONAS-TRIB01' },
	{ river: 'AMAZONAS-TRIB02' },
	{ river: 'AMAZONAS-TRIB04' },
	{ river: 'AMAZONAS-TRIB10' },
	{ river: 'AMAZONE-PERU' },
	{ river: 'AMONIA' },
	{ river: 'AMPIYACU' },
	{ river: 'AMU' },
	{ river: 'ANAUA' },
	{ river: 'ANGUSILLA' },
	{ river: 'APA' },
	{ river: 'APAPORIS' },
	{ river: 'APAPORIS-TRIB-02' },
	{ river: 'APAPORIS-TRIB01' },
	{ river: 'APERE' },
	{ river: 'APUAU' },
	{ river: 'APUAU-TRIB-01' },
	{ river: 'AQUIDABAN' },
	{ river: 'AQUIDAUANA' },
	{ river: 'AQUIO' },
	{ river: 'AQUIO-TRIB01' },
	{ river: 'ARACA' },
	{ river: 'ARACA-TRIB-01' },
	{ river: 'ARACA-TRIB-02' },
	{ river: 'ARACA-TRIB-03' },
	{ river: 'ARAGUAIA' },
	{ river: 'ARAPIUNS' },
	{ river: 'ARAUA' },
	{ river: 'AREIA' },
	{ river: 'ARINOS' },
	{ river: 'ARIPUANA' },
	{ river: 'ARIPUANA-TRIB-01' },
	{ river: 'ARIPUANA-TRIB-03' },
	{ river: 'ARRAIAS' },
	{ river: 'ARRAIAS-D-OESTE' },
	{ river: 'ARRAIAS-D-OESTE-TRIB-01' },
	{ river: 'ASUNTA' },
	{ river: 'ATININGA' },
	{ river: 'ATUCATIQUINI' },
	{ river: 'AUAIA-MICU' },
	{ river: 'AUARIS' },
	{ river: 'AUTAZ-MIRIM' },
	{ river: 'AYCHIYACU' },
	{ river: 'AYPENA' },
	{ river: 'AZUL-TRIB-01' },
	{ river: 'BACAJA' },
	{ river: 'BACAJAI' },
	{ river: 'BADAJOS' },
	{ river: 'BARARATI' },
	{ river: 'BARAUANA' },
	{ river: 'BAUANAS' },
	{ river: 'BENI' },
	{ river: 'BIA' },
	{ river: 'BIATA' },
	{ river: 'BLACK' },
	{ river: 'BLANCO' },
	{ river: 'BOBONAZA' },
	{ river: 'BOCA-DO-ARAPIRI' },
	{ river: 'BOIA' },
	{ river: 'BOIA-TRIB01' },
	{ river: 'BRANCO' },
	{ river: 'BRANCO-DO-ITACUAI' },
	{ river: 'BRANCO-DO-ROOSEVELT' },
	{ river: 'BRAZO-CASIQUIARE-TRIB-10' },
	{ river: 'BUYUYO-TRIB-02' },
	{ river: 'CABACA' },
	{ river: 'CABIXI' },
	{ river: 'CAETE' },
	{ river: 'CAETE-TRIB01' },
	{ river: 'CAFUINI' },
	{ river: 'CAGUAN' },
	{ river: 'CAGUAN-TRIB01' },
	{ river: 'CAHUAPANAS' },
	{ river: 'CAHUINARI' },
	{ river: 'CAHUINARI-TRIB01' },
	{ river: 'CAINARACHE' },
	{ river: 'CAMAIURA' },
	{ river: 'CAMANAU' },
	{ river: 'CAMARARE' },
	{ river: 'CAMISEA' },
	{ river: 'CANAMA' },
	{ river: 'CANANARI' },
	{ river: 'CANDEIAS' },
	{ river: 'CANO-SAN-MIGUEL' },
	{ river: 'CANO-SAN-MIGUEL-TRIB01' },
	{ river: 'CANO-TAPURU' },
	{ river: 'CAPITAO-CARDOSO' },
	{ river: 'CAPUCAPU' },
	{ river: 'CAQUETA' },
	{ river: 'CAQUETA-TRIB-02' },
	{ river: 'CARA-PARANA' },
	{ river: 'CARA-PARANA-TRIB01' },
	{ river: 'CARABINANI' },
	{ river: 'CARAJARI' },
	{ river: 'CARECURU' },
	{ river: 'CAROEBE' },
	{ river: 'CASIQUIARE' },
	{ river: 'CASIQUIARE-TRIB01' },
	{ river: 'CATETE' },
	{ river: 'CATRIMANI' },
	{ river: 'CAUABURI' },
	{ river: 'CAUTARIO' },
	{ river: 'CHANAVAQUIA' },
	{ river: 'CHANDLESS' },
	{ river: 'CHAPARE' },
	{ river: 'CHIMORE' },
	{ river: 'CHINCHIPE' },
	{ river: 'CHIPIRIRI' },
	{ river: 'CIRARE' },
	{ river: 'CITARE' },
	{ river: 'COARI' },
	{ river: 'COMANDANTE-FONTOURA' },
	{ river: 'COMEMORACAO' },
	{ river: 'CONAMBO' },
	{ river: 'CONAMBO-TRIB01' },
	{ river: 'CONFUSO' },
	{ river: 'CONONACO' },
	{ river: 'CORIXA-TRES-IRMAOS-RIO-SAO-LOURENCO' },
	{ river: 'CORRIENTES' },
	{ river: 'COTUHE' },
	{ river: 'COXIM' },
	{ river: 'CRAUARI' },
	{ river: 'CREPORI' },
	{ river: 'CREPORI-TRIB01' },
	{ river: 'CRISTALINO' },
	{ river: 'CUBATE' },
	{ river: 'CUBATE-TRIB01' },
	{ river: 'CUBUA' },
	{ river: 'CUC' },
	{ river: 'CUEMANI' },
	{ river: 'CUIABA' },
	{ river: 'CUIABAZINHO' },
	{ river: 'CUIABAZINHO-TRIB01' },
	{ river: 'CUIARI' },
	{ river: 'CUIUNI' },
	{ river: 'CUIUNI-TRIB01' },
	{ river: 'CUJAR' },
	{ river: 'CULARI' },
	{ river: 'CULEIRAS' },
	{ river: 'CULUENE' },
	{ river: 'CUNIUA' },
	{ river: 'CUNIUA-TRIB-02' },
	{ river: 'CUNIUA-TRIB-03' },
	{ river: 'CUNIUA-TRIB01' },
	{ river: 'CUPARI' },
	{ river: 'CURANJA' },
	{ river: 'CURARAY' },
	{ river: 'CURARAY-TRIB01' },
	{ river: 'CURICURIARI' },
	{ river: 'CURICURIARI-TRIB01' },
	{ river: 'CURIUAU' },
	{ river: 'CURIUJA' },
	{ river: 'CURUA' },
	{ river: 'CURUA-TRIB-03' },
	{ river: 'CURUA-UNA' },
	{ river: 'CURUA-UNA-TRIB-01' },
	{ river: 'CURUA-UNA-TRIB-02' },
	{ river: 'CURUAES' },
	{ river: 'CURUCA' },
	{ river: 'CURURU' },
	{ river: 'CURURU-ACU' },
	{ river: 'CUSHABATAY' },
	{ river: 'DA-ENGENIA' },
	{ river: 'DARAA' },
	{ river: 'DE-MARUPIRI' },
	{ river: 'DEMINI' },
	{ river: 'DEMITI' },
	{ river: 'DO-SANGUE' },
	{ river: 'DOS-APIACAS' },
	{ river: 'DOS-APIACAS-TRIB-02' },
	{ river: 'DOS-MARMELOS' },
	{ river: 'DOS-PEIXES' },
	{ river: 'DOZE-DE-OUTUBRO' },
	{ river: 'DOZE-DE-OUTUBRO-TRIB01' },
	{ river: 'EIRU' },
	{ river: 'ENDIMARI' },
	{ river: 'ENE' },
	{ river: 'ENVIRA' },
	{ river: 'ENVIRA-TRIB-03' },
	{ river: 'ENVIRA-TRIB-05' },
	{ river: 'ENVIRA-TRIB-08' },
	{ river: 'ENVIRA-TRIB-10' },
	{ river: 'FRESCO' },
	{ river: 'FURO-CASTANHO' },
	{ river: 'FURO-DE-SANTA-ROSA' },
	{ river: 'FURQUIM' },
	{ river: 'GALVEZ' },
	{ river: 'GENESHUAYA' },
	{ river: 'GRANDE' },
	{ river: 'GREGORIO' },
	{ river: 'GUAINIA' },
	{ river: 'GUAINIA-TRIB01' },
	{ river: 'GUAJARA' },
	{ river: 'GUANACHE' },
	{ river: 'GUAPORE' },
	{ river: 'GUAPORE-BRASIL-TRIB-03' },
	{ river: 'GUAPORE-BRASIL-TRIB-07' },
	{ river: 'GUARIBA' },
	{ river: 'GUAYAS' },
	{ river: 'HEATH' },
	{ river: 'HUALLAGA' },
	{ river: 'HUALLAGA-TRIB-01' },
	{ river: 'HUALLAGA-TRIB-02' },
	{ river: 'HUALLAGA-TRIB01' },
	{ river: 'HUASAGA' },
	{ river: 'HUAYABAMBA' },
	{ river: 'HUNGURAHUI' },
	{ river: 'IACO' },
	{ river: 'IACO-TRIB01' },
	{ river: 'ICA' },
	{ river: 'ICA-TRIB01' },
	{ river: 'ICANA' },
	{ river: 'ICANA-TRIB-01' },
	{ river: 'ICANA-TRIB01' },
	{ river: 'ICHILO-TRIB-01' },
	{ river: 'IGAPO-ACU' },
	{ river: 'IGAPO-ACU-TRIB-01' },
	{ river: 'IGAPO-ACU-TRIB-01-TRIB01' },
	{ river: 'IGAPO-ACU-TRIB-02' },
	{ river: 'IGAPO-ACU-TRIB-03' },
	{ river: 'IGARAPE-BOM-JARDIM' },
	{ river: 'IGARAPE-CACHORRO' },
	{ river: 'IGARAPE-CARUCARU' },
	{ river: 'IGARAPE-DO-BAU' },
	{ river: 'IGARAPE-DO-LIMAO' },
	{ river: 'IGARAPE-DO-TRIUNFO' },
	{ river: 'IGARAPE-FUMANHA' },
	{ river: 'IGARAPE-ITAPECURU' },
	{ river: 'IGARAPE-ITAPECURU-TRIB01' },
	{ river: 'IGARAPE-NATAL' },
	{ river: 'IGARAPE-RIOZINHO' },
	{ river: 'IGARAPE-SAO-SEBASTIAO' },
	{ river: 'IGARAPE-UARIRI' },
	{ river: 'IMABU' },
	{ river: 'INAMAPUYA' },
	{ river: 'INAMBARI' },
	{ river: 'INAUINI' },
	{ river: 'INAUINI-TRIB01' },
	{ river: 'IPIRANGA' },
	{ river: 'IPITINGA' },
	{ river: 'IPIXUNA' },
	{ river: 'IPIXUNA-TRIB-01' },
	{ river: 'IPIXUNA-TRIB-03' },
	{ river: 'IRIRI' },
	{ river: 'IRIRI-NOVO' },
	{ river: 'IRIRI-TRIB-02' },
	{ river: 'ISIBORO' },
	{ river: 'ITACUAI' },
	{ river: 'ITACUTU' },
	{ river: 'ITANHAUA' },
	{ river: 'ITANHAUA-TRIB-01' },
	{ river: 'ITANHAUA-TRIB01' },
	{ river: 'ITAYA' },
	{ river: 'ITILLA' },
	{ river: 'ITIQUIRA' },
	{ river: 'ITIQUIRA-TRIB01' },
	{ river: 'ITOMANAS' },
	{ river: 'ITUCUMA' },
	{ river: 'ITUI' },
	{ river: 'ITUI-TRIB-02' },
	{ river: 'ITUPARANA' },
	{ river: 'ITUXI' },
	{ river: 'ITUXI-TRIB-02' },
	{ river: 'ITUXI-TRIB-03' },
	{ river: 'JACARE' },
	{ river: 'JACIPARANA-TRIB-01' },
	{ river: 'JAMANXIM' },
	{ river: 'JAMANXIM-TRIB-01' },
	{ river: 'JAMANXIM-TRIB-02' },
	{ river: 'JAMANXIM-TRIB-03' },
	{ river: 'JAMANXIM-TRIB01' },
	{ river: 'JAMARI' },
	{ river: 'JAMINAUA' },
	{ river: 'JANDIATUBA' },
	{ river: 'JANDIATUBA-TRIB01' },
	{ river: 'JANINA' },
	{ river: 'JAPURA' },
	{ river: 'JAPURA-TRIB-01' },
	{ river: 'JAPURA-TRIB-01-TRIB01' },
	{ river: 'JAPURA-TRIB-02' },
	{ river: 'JAPURA-TRIB01' },
	{ river: 'JARAUCU' },
	{ river: 'JARAUCU-TRIB01' },
	{ river: 'JARI' },
	{ river: 'JARI-TRIB01' },
	{ river: 'JARU' },
	{ river: 'JATAPU' },
	{ river: 'JATAPU-TRIB-02' },
	{ river: 'JATAPU-TRIB01' },
	{ river: 'JATOBA' },
	{ river: 'JATUARANA' },
	{ river: 'JAU' },
	{ river: 'JAUAPERI' },
	{ river: 'JAUARU' },
	{ river: 'JAURU' },
	{ river: 'JAVARI' },
	{ river: 'JAVARI-MIRIM-TRIB01' },
	{ river: 'JAVARY' },
	{ river: 'JEJUI-GUAZU' },
	{ river: 'JEJUI-GUAZU-TRIB-01' },
	{ river: 'JEJUI-GUAZU-TRIB-03' },
	{ river: 'JIPARANA' },
	{ river: 'JIPARANA-TRIB-01' },
	{ river: 'JIPARANA-TRIB-03' },
	{ river: 'JUAMI' },
	{ river: 'JUANI' },
	{ river: 'JUFARI' },
	{ river: 'JUINA' },
	{ river: 'JUMA' },
	{ river: 'JURUA' },
	{ river: 'JURUA-TRIB-01' },
	{ river: 'JURUA-TRIB-04' },
	{ river: 'JURUA-TRIB01' },
	{ river: 'JURUENA' },
	{ river: 'JURUPARI' },
	{ river: 'JUTAI' },
	{ river: 'JUTAI-RIVER-RIO-JUTAIZINHO' },
	{ river: 'JUTAI-TRIB-02' },
	{ river: 'JUTAI-TRIB-03' },
	{ river: 'KAPAWI' },
	{ river: 'KAPUIS' },
	{ river: 'KAPUIS-TRIB01' },
	{ river: 'LAS-PIEDRAS-TRIB-01' },
	{ river: 'LAS-PIEDRAS-TRIB-02' },
	{ river: 'LAS-PIEDRAS-TRIB-02-TRIB01' },
	{ river: 'LAS-PIEDRAS-TRIB01' },
	{ river: 'LAS-PIEDRAS-TRIB02' },
	{ river: 'LAURIARI' },
	{ river: 'LIBERTADE' },
	{ river: 'LIBERTADE-TRIB01' },
	{ river: 'LUISA' },
	{ river: 'MACAUA' },
	{ river: 'MACHADINO' },
	{ river: 'MACHADO' },
	{ river: 'MACUSARI' },
	{ river: 'MADEIRA' },
	{ river: 'MADEIRA-TRIB01' },
	{ river: 'MADEIRINHA' },
	{ river: 'MADIDI' },
	{ river: 'MADRE-DE-DIOS' },
	{ river: 'MADRE-DE-DIOS-TRIB01' },
	{ river: 'MAICI' },
	{ river: 'MAICI-TRIB01' },
	{ river: 'MAICIMIRIM-TRIB-01' },
	{ river: 'MAICURU' },
	{ river: 'MAJARI' },
	{ river: 'MALINOWSKI' },
	{ river: 'MAMO' },
	{ river: 'MAMORE' },
	{ river: 'MAMORE-TRIB-01' },
	{ river: 'MAMORIA' },
	{ river: 'MANACAPURU' },
	{ river: 'MANCHARI' },
	{ river: 'MANDUVIRA' },
	{ river: 'MANICORE' },
	{ river: 'MANIQUI' },
	{ river: 'MANISSAUA-MICU' },
	{ river: 'MANITI' },
	{ river: 'MANSO' },
	{ river: 'MANSO-TRIB01' },
	{ river: 'MANU' },
	{ river: 'MANU-TRIB-02' },
	{ river: 'MANU-TRIB01' },
	{ river: 'MANUPARE' },
	{ river: 'MANURIMI' },
	{ river: 'MANURIPI' },
	{ river: 'MAPUERA' },
	{ river: 'MAPUERA-TRIB-02' },
	{ river: 'MAPUERA-TRIB01' },
	{ river: 'MARACANA' },
	{ river: 'MARANON' },
	{ river: 'MARANON-TRIB-01' },
	{ river: 'MARANON-TRIB-01-TRIB01' },
	{ river: 'MARANON-TRIB01' },
	{ river: 'MARAPE' },
	{ river: 'MARAPI' },
	{ river: 'MARAU' },
	{ river: 'MARIE' },
	{ river: 'MARIE-TRIB-01' },
	{ river: 'MARIE-TRIB-05' },
	{ river: 'MARIE-TRIB-06' },
	{ river: 'MARIE-TRIB01' },
	{ river: 'MARUPA' },
	{ river: 'MATAPI' },
	{ river: 'MATAURA' },
	{ river: 'MATAURA-TRIB01' },
	{ river: 'MATUPIRI' },
	{ river: 'MAU' },
	{ river: 'MAYO' },
	{ river: 'MENUAREZINHO' },
	{ river: 'MESAY' },
	{ river: 'MIRANDA' },
	{ river: 'MIRITI' },
	{ river: 'MISHAHUA' },
	{ river: 'MOA' },
	{ river: 'MONO' },
	{ river: 'MORONA' },
	{ river: 'MUACO' },
	{ river: 'MUCAJAI' },
	{ river: 'MUCUIM' },
	{ river: 'MURU' },
	{ river: 'MUTUM' },
	{ river: 'MUTUMZINHO' },
	{ river: 'NANAY' },
	{ river: 'NANAY-TRIB-03' },
	{ river: 'NANAY-TRIB-04' },
	{ river: 'NANAY-TRIB-04-TRIB01' },
	{ river: 'NANAY-TRIB01' },
	{ river: 'NANGARITZA' },
	{ river: 'NANGARITZA-TRIB-01' },
	{ river: 'NAPO' },
	{ river: 'NAPO-TRIB-02' },
	{ river: 'NAPO-TRIB-03' },
	{ river: 'NAPO-TRIB01' },
	{ river: 'NAVILECIA' },
	{ river: 'NEGRO' },
	{ river: 'NEGRO-TRIB-04' },
	{ river: 'NEGRO-TRIB-05' },
	{ river: 'NEGRO-TRIB-07' },
	{ river: 'NEGRO-TRIB-12' },
	{ river: 'NEGRO-TRIB-20' },
	{ river: 'NEGRO-TRIB-24' },
	{ river: 'NEGRO-TRIB-28' },
	{ river: 'NEGRO-TRIB-31' },
	{ river: 'NEGRO-TRIB-38' },
	{ river: 'NEGRO-TRIB-45' },
	{ river: 'NEGRO-TRIB-45-TRIB01' },
	{ river: 'NEGRO-TRIB-55' },
	{ river: 'NEGRO-TRIB01' },
	{ river: 'NESHUYA' },
	{ river: 'NHAMUNDA' },
	{ river: 'NIOQUE' },
	{ river: 'NOVO' },
	{ river: 'NUCURAY' },
	{ river: 'ORINOCO-TRIB01' },
	{ river: 'OROZA' },
	{ river: 'ORTEGUAZA' },
	{ river: 'ORTHON' },
	{ river: 'PACAAS-NOVOS' },
	{ river: 'PACAHUARA' },
	{ river: 'PACAJA' },
	{ river: 'PACHITEA' },
	{ river: 'PACU' },
	{ river: 'PADAUARI' },
	{ river: 'PADRE-VELHO-TRIB01' },
	{ river: 'PALCAZU' },
	{ river: 'PALCAZU-TRIB-01' },
	{ river: 'PAMPAS' },
	{ river: 'PAPAGAIO' },
	{ river: 'PAPURI' },
	{ river: 'PARACONI' },
	{ river: 'PARAGUA' },
	{ river: 'PARAGUAI' },
	{ river: 'PARAGUAI-MIRIM-TAQUARI' },
	{ river: 'PARAGUAI-TRIB-01' },
	{ river: 'PARAGUAI-TRIB-11' },
	{ river: 'PARAGUAI-TRIB-13' },
	{ river: 'PARAGUAI-TRIB-17' },
	{ river: 'PARAGUAI-TRIB-18' },
	{ river: 'PARAGUAI-TRIB01' },
	{ river: 'PARAGUAY' },
	{ river: 'PARANA-BREU' },
	{ river: 'PARANA-COPEA' },
	{ river: 'PARANA-DO-CUXIU' },
	{ river: 'PARANA-PIORINI' },
	{ river: 'PARANA-PITEIRA' },
	{ river: 'PARANA-TAMBAQUI' },
	{ river: 'PARANAITA' },
	{ river: 'PARANAPURA' },
	{ river: 'PARANAPURA-TRIB01' },
	{ river: 'PARANATINGA' },
	{ river: 'PARAUARI' },
	{ river: 'PARDO' },
	{ river: 'PARDO-DO-CURUCA' },
	{ river: 'PARDO-TRIB01' },
	{ river: 'PARU' },
	{ river: 'PARU-D-OESTE' },
	{ river: 'PARU-D-OESTE-TRIB01' },
	{ river: 'PARU-DE-ESTE' },
	{ river: 'PASTAZA' },
	{ river: 'PASTAZA-TRIB01' },
	{ river: 'PAUINI' },
	{ river: 'PAUINI-RIVER-RIO-MUACO' },
	{ river: 'PAXIUBA' },
	{ river: 'PEDREIRA' },
	{ river: 'PENATECAUA' },
	{ river: 'PERDIDO' },
	{ river: 'PERENE' },
	{ river: 'PICHIS' },
	{ river: 'PICHIS-TRIB-02' },
	{ river: 'PIMENTA-BUENO' },
	{ river: 'PINHUA' },
	{ river: 'PINTOYACO' },
	{ river: 'PIQUIRI' },
	{ river: 'PIRAIAUAIA' },
	{ river: 'PIRANHAS' },
	{ river: 'PIRATUCU' },
	{ river: 'POANA' },
	{ river: 'PONTE-DE-PEDRA' },
	{ river: 'PORTO-SEGURO' },
	{ river: 'POTRO' },
	{ river: 'PRETO' },
	{ river: 'PRETO-DO-AUAIA' },
	{ river: 'PRETO-DO-IGAPO-ACU' },
	{ river: 'PRETO-DO-UNINI' },
	{ river: 'PRIMAVERA' },
	{ river: 'PUNICICI' },
	{ river: 'PURE' },
	{ river: 'PURETE' },
	{ river: 'PURUS' },
	{ river: 'PURUS-TRIB-03' },
	{ river: 'PURUS-TRIB-06' },
	{ river: 'PURUS-TRIB-08' },
	{ river: 'PURUS-TRIB01' },
	{ river: 'PUTUMAYO' },
	{ river: 'PUTUMAYO-TRIB-01' },
	{ river: 'PUTUMAYO-TRIB-03' },
	{ river: 'PUTUMAYO-TRIB-04' },
	{ river: 'PUTUMAYO-TRIB01' },
	{ river: 'QUARANAY' },
	{ river: 'QUARANAY-TRIB01' },
	{ river: 'QUEBRADA-PIAPIA' },
	{ river: 'QUERARI' },
	{ river: 'QUINO' },
	{ river: 'QUIQUIBEY' },
	{ river: 'QUIXITO' },
	{ river: 'RAPULO' },
	{ river: 'RIOZINHO' },
	{ river: 'RIOZINHO-DO-ANFRISIO' },
	{ river: 'RIOZINHO-TRIB-02' },
	{ river: 'RONURO' },
	{ river: 'ROOSEVELT' },
	{ river: 'ROOSEVELT-TRIB-01' },
	{ river: 'SABILA' },
	{ river: 'SABILA-TRIB01' },
	{ river: 'SACRE' },
	{ river: 'SAN-JULIAN' },
	{ river: 'SAN-MARTIN' },
	{ river: 'SAN-MIGUEL' },
	{ river: 'SAN-PABLO' },
	{ river: 'SANTA-MARIA' },
	{ river: 'SANTA-ROSA' },
	{ river: 'SANTIAGO' },
	{ river: 'SAO-BENEDITO' },
	{ river: 'SAO-BENEDITO-II' },
	{ river: 'SAO-BENEDITO-TRIB-01' },
	{ river: 'SAO-JOAO-DA-BARRA' },
	{ river: 'SAO-LOURENCO' },
	{ river: 'SAO-MIGUEL' },
	{ river: 'SAO-TOME' },
	{ river: 'SAO-VENCESLAU' },
	{ river: 'SAUERUINA' },
	{ river: 'SECURE' },
	{ river: 'SEPAHUA' },
	{ river: 'SEPUTUBA' },
	{ river: 'SETE-DE-SETEMBRO' },
	{ river: 'SHAMBIRA' },
	{ river: 'SHAMBIRA-TRIB1' },
	{ river: 'SHAMBOYACU' },
	{ river: 'SHESHEA' },
	{ river: 'SHESHEA-TRIB01' },
	{ river: 'SHISHINAHUA' },
	{ river: 'SIAPA' },
	{ river: 'SIAPA-TRIB01' },
	{ river: 'SIETE-PUNTAS' },
	{ river: 'SOLIMOES' },
	{ river: 'SOLIMOES-TRIB01' },
	{ river: 'SUCUNDURI' },
	{ river: 'SUCUNDURI-TRIB01' },
	{ river: 'SUIA-MICU' },
	{ river: 'SUMIDOURO-GRANDE' },
	{ river: 'SURUMU' },
	{ river: 'TADARIMANA' },
	{ river: 'TAHUAMANU' },
	{ river: 'TAHUAMANU-TRIB01' },
	{ river: 'TAHUAYO' },
	{ river: 'TAKUTU' },
	{ river: 'TAMBO' },
	{ river: 'TAMBOPATA' },
	{ river: 'TAMBOPATA-TRIB01' },
	{ river: 'TAMITATOALA' },
	{ river: 'TAPAJOS' },
	{ river: 'TAPAJOS-TRIB-01' },
	{ river: 'TAPAJOS-TRIB-03' },
	{ river: 'TAPARA' },
	{ river: 'TAPAUA' },
	{ river: 'TAPAUA-TRIB-01' },
	{ river: 'TAPAUA-TRIB-03' },
	{ river: 'TAPAUA-TRIB01' },
	{ river: 'TAPICHE' },
	{ river: 'TAPICHE-TRIB-01' },
	{ river: 'TAQUARI' },
	{ river: 'TARAUACA' },
	{ river: 'TARTARUGA' },
	{ river: 'TEFE' },
	{ river: 'TEFE-TRIB01' },
	{ river: 'TEFFE' },
	{ river: 'TEIA' },
	{ river: 'TELES-PIRES' },
	{ river: 'TELES-PIRES-TRIB-02' },
	{ river: 'TELES-PIRES-TRIB01' },
	{ river: 'TENENTE-MARQUES' },
	{ river: 'TIGRE' },
	{ river: 'TIGRE-TRIB-01' },
	{ river: 'TIJAMUCHI' },
	{ river: 'TIPUTINI' },
	{ river: 'TIQUIE' },
	{ river: 'TIQUIE-TRIB-01' },
	{ river: 'TIQUIE-TRIB-02' },
	{ river: 'TOCANTINS' },
	{ river: 'TONANTINS' },
	{ river: 'TRIB-01' },
	{ river: 'TRIGRILLO' },
	{ river: 'TROMBETAS' },
	{ river: 'TROMBETAS-TRIB-01' },
	{ river: 'TROMBETAS-TRIB-02' },
	{ river: 'TUICHI' },
	{ river: 'TUNIA-O-MACAYA' },
	{ river: 'TUPANA' },
	{ river: 'TURI' },
	{ river: 'UARINI' },
	{ river: 'UATUMA' },
	{ river: 'UAUPES' },
	{ river: 'UAUPES-TRIB-02' },
	{ river: 'UCAYALI' },
	{ river: 'UCAYALI-TRIB-01' },
	{ river: 'UCAYALI-TRIB-01-TRIB01' },
	{ river: 'UCAYALI-TRIB-05' },
	{ river: 'UCAYALI-TRIB-05-TRIB01' },
	{ river: 'UCAYALI-TRIB-06' },
	{ river: 'UCAYALI-TRIB01' },
	{ river: 'UMARI' },
	{ river: 'UNEIUXI' },
	{ river: 'UNEIUXI-TRIB01' },
	{ river: 'UNINI' },
	{ river: 'UNINI-TRIB-03' },
	{ river: 'UNINI-TRIB01' },
	{ river: 'URARICAA' },
	{ river: 'URARICOERA' },
	{ river: 'URARICOERA-TRIB-02' },
	{ river: 'URITUYACU' },
	{ river: 'URUARA' },
	{ river: 'URUBAMBA' },
	{ river: 'URUBAMBA-TRIB-01' },
	{ river: 'URUBAMBA-TRIB-01-TRIB01' },
	{ river: 'URUBU' },
	{ river: 'URUCU' },
	{ river: 'URUMURUM' },
	{ river: 'URUPA' },
	{ river: 'VERDE' },
	{ river: 'VERMELHO' },
	{ river: 'VILA-NOVA' },
	{ river: 'VILCANOTA' },
	{ river: 'VON-DEN-STEINEN' },
	{ river: 'XERIUINI' },
	{ river: 'XERIUINI-TRIB01' },
	{ river: 'XERUA' },
	{ river: 'XIE' },
	{ river: 'XINGU' },
	{ river: 'XINGU-TRIB-07' },
	{ river: 'XINZIM' },
	{ river: 'XIXE' },
	{ river: 'YACUMA' },
	{ river: 'YAGUAS' },
	{ river: 'YAPACANI' },
	{ river: 'YARI' },
	{ river: 'YARI-TRIB-01' },
	{ river: 'YARUA' },
	{ river: 'YASUNI' },
	{ river: 'YATA' },
	{ river: 'YPANE' },
	{ river: 'YPANE-TRIB-01' },
	{ river: 'YURAC' },
	{ river: 'YURUA' },
];

export const LAYERS_OPTIONS = [   
    { value: "amazon_cog3857_2.tif", label: "amazon_cog3857_2.tif", bounds: [-80.0, -20.5, -45.0, 9.5], rescaleMin: 0, rescaleMax: 255, colormap: "ocean", opacity: 0.8  },
	{ value: "CaMA-Flood_cog.tif", label: "CaMA-Flood_cog.tif", "bounds": [-80.15625000000001, -20.63278425038801, -45.0, 5.615985819155347], "rescaleMin": 0, "rescaleMax": 11, "colormap": "magma", "opacity": 0.8 },
    { value: "Floodplains_Interfluvial_cog.tif", label: "Floodplains_Interfluvial_cog.tif", "bounds": [-81.5625, -21.94304553343818, -44.99999999999999, 11.178401873711778], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
	{ value: "Park_LowerAmazon_cog.tif", label: "Park_LowerAmazon_cog.tif", "bounds": [-71.015625, -7.01366792756663, -49.921875, 0.0], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
	 { value: "ALOS2_Jensen_cog.tif", label: "ALOS2_Jensen_cog.tif", "bounds": [-77.080078125, -7.013667927566615, -72.94921875, -2.9869273933348555], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
];

export const LAYERS_BACKUP = [
    { value: "AgreementMax.tif", label: "AgreementMax.tif", "bounds": [
-79.99999999992724,
-19.999999999998863,
-44.99999999995907,
9.999999999999432
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 }, 
    { value: "AgreementMin.tif", label: "AgreementMin.tif", "bounds": [
-79.99999999992724,
-19.999999999998863,
-44.99999999995907,
9.999999999999432
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "ALOS_Arnesen_Curuai.tif", label: "ALOS_Arnesen_Curuai.tif", "bounds": [
-56.009213,
-2.356165999999999,
-55.010946000000004,
-1.9045489999999998
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "ALOS_Ovando.tif", label: "ALOS_Ovando.tif", "bounds": [
-67.99031524054286,
-19.95055696157847,
-59.590579106403716,
-9.999484672375079
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "ALOS_Pinel.tif", label: "ALOS_Pinel.tif", "bounds": [
-60.45719141735888,
-3.682177584788925,
-60.135751417358875,
-3.329052584788925
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "ALOS2_Jensen.tif", label: "ALOS2_Jensen.tif", "bounds": [
-76.99977777777778,
-7.000222222222222,
-72.99977777777778,
-3.0002222222222223
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "amazon.tif", label: "amazon.tif", "bounds": [
-79.99999999992724,
-19.999999999998863,
-44.99999999995907,
9.999999999999432
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "amazon_cog.tif", label: "amazon_cog.tif", bounds: [-79.99999999992724, -19.999999999998863, -44.99999999995907, 9.999999999999432], rescaleMin: 0, rescaleMax: 255, colormap: "ocean", opacity: 0.8  },
    { value: "Amazon30km.tif", label: "Amazon30km.tif", "bounds": [
-79.61248779296898,
-20.51529812076892,
-48.412487792968975,
5.284701879231079
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "amazoncog.tif", label: "amazoncog.tif", "bounds": [
-79.99999999992724,
-19.999999999998863,
-44.99999999995907,
9.999999999999432
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "Bonnet_Janauaca.tif", label: "Bonnet_Janauaca.tif", "bounds": [
-60.454906,
-3.681047,
-60.140044,
-3.336971
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "CaMA-Flood.tif", label: "CaMA-Flood.tif", "bounds": [
-79.99791717529297,
-19.99791717529297,
-45.00208282470703,
4.9979166984558105
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "Floodplains_Interfluvial.tif", label: "Floodplains_Interfluvial.tif", "bounds": [
-79.999999999927,
-19.999999998799996,
-45.000000001327,
10
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "GIEMS-2.tif", label: "GIEMS-2.tif", "bounds": [
-79.61248779296898,
-20.47918701171892,
-48.38418918184398,
5.252931043848079
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "Park_LowerAmazon.tif", label: "Park_LowerAmazon.tif", "bounds": [
-70.51122111351091,
-6.903794453474413,
-49.99897837039731,
0.0005662020905499344
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "Pinel_Janauaca.tif", label: "Pinel_Janauaca.tif", "bounds": [
-60.398514544904394,
-3.500233127840464,
-60.161391751697614,
-3.3365850029512805
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "Reference5km.tif", label: "Reference5km.tif", "bounds": [
-79.61248779296898,
-20.47918701171892,
-48.487487792719975,
5.27081298848708
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "RosenqvistMin.tif", label: "RosenqvistMin.tif", "bounds": [
-79.61248779296898,
-20.479186985955977,
-49.29115445963568,
5.283479680710663
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "RosenqvistMin2.tif", label: "RosenqvistMin2.tif", "bounds": [
-79.61248779296898,
-20.479186985955977,
-49.29115445963568,
5.283479680710663
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "RosenqvistMin3.tif", label: "RosenqvistMin3.tif", "bounds": [
-79.61248779296898,
-20.479186985955977,
-49.29115445963568,
5.283479680710663
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "RosenqvistMin4.tif", label: "RosenqvistMin4.tif", "bounds": [
-79.61248779296898,
-20.479186985955977,
-49.29115445963568,
5.283479680710663
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "Rudorff_Curuai.tif", label: "Rudorff_Curuai.tif", "bounds": [
-56.095977,
-2.395286,
-55.003437,
-1.7872999999999999
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "Similarity30km_5products.tif", label: "Similarity30km_5products.tif", "bounds": [
-79.82823529411792,
-20.64000000000007,
-48.261176470588396,
5.463529411764725
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "SWAF_HR.tif", label: "SWAF_HR.tif", "bounds": [
-79.99999999992724,
-19.999999999998863,
-44.99999999995907,
9.999999999999432
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 },
    { value: "THMB.tif", label: "THMB.tif", "bounds": [
-79.95832061767578,
-20.95832824707031,
-45.041656494140625,
5.958335876464844
], "rescaleMin": 0, "rescaleMax": 11, "colormap": "ocean", "opacity": 0.8 }
];